import infoIcon from "icons/info.svg";
import { number } from "prop-types";

import classes from "./EmptyDocumentIcon.module.scss";

const EmptyDocumentIcon = ({ size = 16 }) => (
  <img
    src={infoIcon}
    alt="Empty document"
    className={classes["empty_document_icon"]}
    data-testid="empty-document-icon"
    width={size}
    height={size}
  />
);

EmptyDocumentIcon.propTypes = {
  size: number,
};

export default EmptyDocumentIcon;
